export const apiCrmDomain = "https://ironlinc-crm.azurewebsites.net";
